module.exports = __webpack_public_path__ + "img/sim-card.c9cff20.png";